import script from "./UTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UTable.vue?vue&type=script&setup=true&lang=ts"

import "./UTable.vue?vue&type=style&index=0&id=b960c9c2&lang=scss"

const __exports__ = script;

export default __exports__